import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

import { defineNuxtPlugin } from '#app';
import * as pkg from '@/package.json';

export default defineNuxtPlugin((nuxtApp) => {
	const { vueApp } = nuxtApp;

	const config = useRuntimeConfig();

	const release = `${config.PROJECT}@${pkg.version}`;
	const environment = config.SENTRY_ENVIRONMENT;

	Sentry.init({
		app: [vueApp],
		dsn: config.VUE_APP_SENTRY_DSN,
		release,
		environment,
		integrations: [
			new BrowserTracing({
				routingInstrumentation: Sentry.vueRouterInstrumentation(nuxtApp.$router),
				// tracingOrigins: [config.VUE_APP_BASE_API, /^\//],
				// tracePropagationTargets: [config.VUE_APP_BASE_API, /^\//],
			}),
		],
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0,
		beforeSend(event, hint) {
			// Check if it is an exception, and if so, log it.
			if (event.exception) {
				// eslint-disable-next-line no-console
				console.error(`[Exeption handled by Sentry]: (${hint.originalException})`, { event, hint });
			}
			// Continue sending to Sentry
			return event;
		},
		ignoreErrors: [
			'AxiosError: Request failed with status code 401',
			'AxiosError: Request failed with status code 404',
			'ORDER_NOT_FOUND',
		],
	});

	vueApp.mixin(
		Sentry.createTracingMixins({ trackComponents: true, timeout: 2000, hooks: ['activate', 'mount', 'update'] }),
	);
	Sentry.attachErrorHandler(vueApp, {
		logErrors: false,
		attachProps: true,
		trackComponents: true,
		timeout: 2000,
		hooks: ['activate', 'mount', 'update'],
	});

	return {
		provide: {
			sentrySetContext: Sentry.setContext,
			sentrySetUser: Sentry.setUser,
			sentrySetTag: Sentry.setTag,
			sentryAddBreadcrumb: Sentry.addBreadcrumb,
			sentryCaptureException: Sentry.captureException,
		},
	};
});
